var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g({class:_vm.iconName,attrs:{"aria-hidden":"true"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }